import { truncateText } from '@infl-ts/util-string-truncate-text';
import { pipe } from 'fp-ts/function';
import { Head } from './head';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PageMetaData = function PageMetaData(_ref) {
  var title = _ref.title,
      description = _ref.description,
      imgUrl = _ref.imgUrl,
      siteName = _ref.siteName,
      fbId = _ref.fbId;
  return pipe(description, function (s) {
    return s.replaceAll('\n', ' ');
  }, truncateText(160), function (shortDescription) {
    return /*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("meta", {
        name: "description",
        content: shortDescription
      }, "search-description"), /*#__PURE__*/_jsx("meta", {
        itemProp: "name",
        content: title
      }, "item-name"), /*#__PURE__*/_jsx("meta", {
        itemProp: "description",
        content: shortDescription
      }, "item-description"), /*#__PURE__*/_jsx("meta", {
        name: "twitter:card",
        content: "summary"
      }), /*#__PURE__*/_jsx("meta", {
        name: "twitter:title",
        content: title
      }, "twitter-title"), /*#__PURE__*/_jsx("meta", {
        name: "twitter:description",
        content: shortDescription
      }, "twitter-description"), /*#__PURE__*/_jsx("meta", {
        name: "twitter:image:src",
        content: imgUrl
      }, "twitter-image"), fbId && /*#__PURE__*/_jsx("meta", {
        property: "fb:app_id",
        content: fbId
      }, "fb-id"), siteName && /*#__PURE__*/_jsx("meta", {
        property: "og:site_name",
        content: siteName
      }, "site-name"), /*#__PURE__*/_jsx("meta", {
        property: "og:title",
        content: title
      }, "title"), /*#__PURE__*/_jsx("meta", {
        property: "og:description",
        content: shortDescription
      }, "description"), /*#__PURE__*/_jsx("meta", {
        property: "og:image",
        content: imgUrl
      }, "image")]
    });
  });
};